<!-- 编辑简历 -->
<template>
  <div style="background-color: #f6f6f6;padding-top: 80px;">
    <!-- 行业 -->
    <div v-if="isindustry==true" class="shade-unify"></div>
    <div v-if="isindustry==true" class="hotss-unify" style="z-index: 999;position: fixed;left: 0;right: 0;height: 500px">
<!--      hots-editResume_isindustryEditResumevue-->
      <div class="hots-titles-unify" style="overflow: hidden;padding-top: 25px;">
        <div style="float: left;">请选择职位类别</div>
        <img alt="" src="../../assets/close.png"
             style="float: right;width: 24px;height: 24px;margin-right: 16px;cursor: pointer" @click="close()">
      </div>
      <div class="hots-contents-unify">
        <div class="hots-left-unify">
          <div v-for="(item,index) in tradeList" :key="index" class="hots-left-label-unify"
               @mouseenter="changePosition(index)">
            <div :class="index==tradeListIndex ? 'active' : ''">{{ item.name }}</div>
          </div>
        </div>
        <div :key="freshKey" class="hots-right-unify">
          <div  class="hots-right-box-unify">
<!--            <div class="hots-right-h1">{{ item.name }}</div>-->
            <div class="hots-right-cont-unify">
              <div  style="padding: 5px;border-radius: 4px;background-color: #F1F2F6;" v-for="(item,index) in tradeList[tradeListIndex].list" :key="index"
                   @click="chooseTrade(tradeList[tradeListIndex].id, item.name,index)">{{ item.name }}
              </div>
<!--              v-for="(items,indexs) in tradeList[tradeListIndex].list[index].list" :key="indexs"-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业 -->
    <!-- 证书 -->
    <div v-if="iscertificate==true" class="shade"></div>
    <div v-if="iscertificate==true" class="hots-editResume">
      <div class="hots-titles" style="overflow: hidden;padding-top: 25px;">
        <div style="float: left;">请选择资格证书</div>
        <img alt="" src="../../assets/close.png"
             style="float: right;width: 24px;height: 24px;margin-right: 16px;cursor: pointer" @click="close()">
      </div>
      <div class="hots-contents">
        <div class="hots-left">
          <div v-for="(item,index) in certificateList" :key="index" class="hots-left-label"
               @mouseenter="changePositions(index)">
            <div :class="index==certificateListIndex ? 'active' : ''">{{ item.name }}</div>
          </div>
        </div>
        <div :key="freshKeys" class="hots-right">
          <div class="hots-right-box">
            <div class="hots-right-cont">
              <div v-for="(item,index) in certificateList[certificateListIndex].list" :key="index"
                   :class="item.check==true?'hots-right-cont-active':''" class="hots-right-cont-div"
                   @click="checkCertificate(item.id)">{{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hots-btns">
        <div @click="selectCertificateList()">确认</div>
        <div @click="close()">取消</div>
      </div>
    </div>
    <!-- 证书 -->
    <div class="resume-box">
      <!--2023-4-24-->
      <div class="resume-left">
        <div class="resume-modular-filling">
          <div class="resume-modular-fillBox">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">基础信息</div>
            <!--基础信息，左边信息右边头像-->
            <div style="width: 600px;display: inline-block">
              <!-- 姓名、性别-->
              <div class="resume-modular-fill">
                <div class="resume-fillDetails">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">姓名</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content">
                    <input v-model="jobResume.name" class="resume-fill-detils" type="text">
                  </div>
                </div>

                <div class="resume-fillDetails">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">性别</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content">
                    <el-radio-group v-model="sex" @change="handleSex" style="display: flex">
                      <el-radio-button :value="0" label="男" type="index" class="el-radio-button__inner-EditResume"></el-radio-button>
                      <el-radio-button :value="1" label="女" type="index" class="el-radio-button__inner-EditResume" style="margin-left: 5%;border-left: 1px solid #dfdfdf !important;"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
              </div>
              <!-- 姓名、性别-->
              <!-- 出生日期、联系方式-->
              <div class="resume-modular-fill">
                <div class="resume-fillDetails" style="padding-bottom: 6px;">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">出生日期</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content" style="border: none;position: relative;height: 36px;">
                    <el-date-picker v-model="jobResume.birthday" class="resume-fillDetails-content-picker" placeholder="请选择"
                                    type="date" value-format="yyyy-MM-dd" @change="dataSearch"></el-date-picker>
                    <!--                    <el-date-picker v-model="jobResume.birthDay" class="resume-fillDetails-content-picker" placeholder="请选择"-->
                    <!--                                    type="date" value-format="yyyy-MM-dd" @change="dataSearch"></el-date-picker>-->
                    <div class="pull-down-icon-box" @change="dataSearch" style="position: unset">
                      <i class="el-icon-arrow-down el-dropdown"></i>
                    </div>
                  </div>
                </div>

                <div class="resume-fillDetails" style="padding-bottom: 6px;">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">联系方式</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content" style="border: none;">
                    <input v-model="jobResume.phone" class="resume-fill-detils" maxlength="11" type="text">
                  </div>
                </div>
              </div>
              <!-- 工作经验、当前状态-->
              <div class="resume-modular-fill">
                <div class="resume-fillDetails">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">工作经验</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content">
                    <el-select v-model="jobResume.work" placeholder="请选择工作经验" class="jobResumeWork">
                      <el-option
                        v-for="item in workList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="resume-fillDetails">
                  <div class="fillBusinessDetails-name">
                    <div class="fillResumeDetails-name">当前状态</div>
                    <div class="asterisk">*</div>
                  </div>
                  <div class="resume-fillDetails-content">
                    <el-select v-model="jobResume.condition" placeholder="请选择当前状态" class="jobResumeCondition">
                      <el-option
                        v-for="item in conditionList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <!-- 工作经验、当前状态-->
            </div>
            <!--头像-->
            <div style="width: 141px;margin-left: 50px;float: right;margin-top: 35px">
              <div :style="{'height': imageSrc==''?'188px':'188px'}" class="resume-fillDetails resume-fillDetails-headerPhoto">
                <div class="resume-fillDetails-headerPhoto-after">
                  <img v-if="jobResume.logo!=''" :src="jobResume.logo" style="height:100%;width:100%;"/></div>
                <span style="position: absolute;top: 0;height: 186px;width: 138px">
                  <input ref="fileInput" type="file" v-on:change="test()" class="resume-fillDetails-headerPhoto-file" style="cursor: pointer">
                </span>
              </div>
              <div style="font-size: 16px;margin-top: 13px;color: #6D6D6D;text-align: center">上传本人照片</div>
            </div>
          </div>
          <!--求职期望-->
          <div class="resume-modular-fillBox">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">求职期望</div>
            <!-- 期望职位、工作地区-->
            <div class="resume-modular-fill">
              <div class="resume-fillDetails" style="padding-bottom: 6px;">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">期望职位</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content">
<!--                  <el-dropdown style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF;">-->
                  <div style="height: 36px;line-height: 36px;width: 99%;border: 1px solid #DFDFDF;">
                    <span class="el-dropdown-link" style="padding-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;color: #606266;"
                          @click="selectIndustry()" >{{ jobResume.jobName }}<i class="el-icon-arrow-down el-icon--right" style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0;color: #c0cadc"></i>
                    </span>
                  </div>
<!--                    <span class="el-dropdown-link"-->
<!--                          style="padding-left: 1rem;display: inline-block;position: relative;width: 100%;height: 100%;"-->
<!--                          @click="selectIndustry()" >{{ jobResume.jobName }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"style="float: right;position: absolute;right: 30px;line-height: 36px;margin-top: 0"></i>-->
<!--                    </span>-->
<!--                    <el-dropdown-menu>-->
<!--                      <el-dropdown-item></el-dropdown-item>-->
<!--                    </el-dropdown-menu>-->
<!--                  </el-dropdown>-->
                </div>
              </div>
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">期望地区</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content" style="display: flex">
                  <el-select v-model="provinceId"  @change="handleArea" placeholder="请选择省" style="margin-right: 5px;" class="cityItem-editResume">
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select v-model="cityId" @change="handleCity" placeholder="请选择市" style="margin-right: 5px;" class="cityItem-editResume">
                    <el-option
                      v-for="item in cityList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select v-model="districtId" @change="handleDistrict" placeholder="请选择区" class="cityItem-editResume">
                    <el-option
                      v-for="item in districtList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- 期望职位、工作地区-->
            <!-- 求职类型、期望薪资-->
            <div class="resume-modular-fill">
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">求职类型</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content">
                  <el-select v-model="jobResume.type" placeholder="请选择求职类型" class="jobResumeType">
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">期望薪资</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content">
                  <el-select v-model="jobResume.salaryId" placeholder="请选择期望薪资" class="testMoney-editResume">
                    <el-option
                      v-for="item in salaryList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <!--自我介绍-->
          <div class="resume-modular-fillBox">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">自我介绍</div>
            <div class="resume-modular-fill">
              <div class="resume-fill-introduce">
                <textarea type="text" class="resume-fill-textarea" name="" id="" cols="30" rows="5" v-model="jobResume.selfIntroduction" placeholder="请输入自我介绍："></textarea>
              </div>
            </div>
          </div>
          <!--工作经历-->
          <!--新增工作经历-->
          <li class="resume-modular-fillBox newWorkList" v-for="(item,index) in newWorkList" :key="index" id="editModal" style="list-style: none;">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">
              <div style="display: inline-block">工作经历{{index+1}}</div>
              <div @click="addWorkList" v-if="index==0" style="float: right;color: #027FFE;font-weight: 400;height: 25px;line-height: 25px;display: flex;align-items: center;cursor: pointer" >
                <img src="../../assets/add-more.png" alt="" style="width: 18px;height: 18px;margin-right: 5px;">
                新增
              </div>
              <div @click="DeleteAddWorkList" v-if="index!=0" style="float: right;color: #027FFE;font-weight: 400;height: 25px;line-height: 25px;display: flex;align-items: center;cursor: pointer" >
                <img src="../../assets/reduce.png" alt="" style="width: 18px;height: 18px;margin-right: 5px;">
                删除
              </div>
            </div>
            <span style="display: none">{{ item.id }}</span>
            <div class="resume-modular-fill">
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">公司</div>
                </div>
                <div class="resume-fillDetails-content">
                  <input class="resume-fill-detils" type="text" v-model="item.companyName">
                </div>
              </div>
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">职位</div>
                </div>
                <div class="resume-fillDetails-content">
                  <input class="resume-fill-detils" type="text" v-model="item.jobInfo">
                </div>
              </div>
            </div>
            <div class="resume-modular-fill">
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">时间</div>
                </div>
                <div class="resume-fillDetails-content"
                     style="border: none;position: relative;display: flex;align-items: center">
                  <el-date-picker v-model="item.startTime" class="resume-fillDetails-content-picker" placeholder="请选择"
                                  type="date" value-format="yyyy-MM-dd" @change="dataSearch"></el-date-picker>
                  <div class="pull-down-icon-box" @change="dataSearch">
                    <!--                    <i class="el-icon-arrow-down el-dropdown"></i>-->
                  </div>
                  <div style="padding: 7px">至</div>

                  <el-date-picker v-model="item.endTime" class="resume-fillDetails-content-picker" placeholder="请选择"
                                  type="date" value-format="yyyy-MM-dd" @change="dataSearch"></el-date-picker>
                  <div class="pull-down-icon-box" @change="dataSearch">
                    <!--                      <i class="el-icon-arrow-down el-dropdown"></i>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="resume-modular-fill">
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">工作描述</div>
                </div>
                <div class="resume-fill-introduce">
                        <textarea type="text" class="resume-fill-textarea" name="" id="" cols="30" rows="4" style=""
                                  v-model="item.content"
                                  placeholder="请输入工作描述："></textarea>
                </div>
              </div>
            </div>
          </li>
          <!--毕业院校-->
          <div class="resume-modular-fillBox">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">教育经历</div>
            <div class="resume-modular-fill">
              <div class="resume-fillDetails" style="padding-bottom: 6px;">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">毕业学校</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content" style="border: none;">
                  <input v-model="jobResume.school" class="resume-fill-detils" type="text">
                </div>
              </div>
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">学历</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content">
                  <el-select v-model="jobResume.edu" placeholder="请选择学历" class="jobResumeEdu-editResume">
                    <el-option
                      v-for="item in eduList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="resume-modular-fill">
              <div class="resume-fillDetails" style="padding-bottom: 6px;">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">专业</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content" style="border: none;">
                  <input v-model="jobResume.major" class="resume-fill-detils" type="text">
                </div>
              </div>
              <div class="resume-fillDetails">
                <div class="fillBusinessDetails-name">
                  <div class="fillResumeDetails-name">毕业时间</div>
                  <div class="asterisk">*</div>
                </div>
                <div class="resume-fillDetails-content" style="border: none;position: relative;height: 36px">
                  <el-date-picker v-model="jobResume.graduationDate" class="resume-fillDetails-content-picker" placeholder="请选择"
                                  type="date" value-format="yyyy-MM-dd" @change="dataSearch"></el-date-picker>
                  <div class="pull-down-icon-box" style="position: unset">
                    <i class="el-icon-arrow-down el-dropdown"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--资格证书-->
          <div class="resume-modular-fillBox">
            <img src="../../assets/index-line.png" style="width:45px;height:5px;margin-bottom: 11px;" alt="">
            <div class="resume-modular-title-name">资格证书</div>

            <div class="resume-modular-tabel" :style="{'height': certificate==''?'30px':''}" @click="opencertificate()">
              <div>{{ certificate }}</div>
              <img class="resume-modular-add" src="../../assets/resume-icon5.png"/>
            </div>
          </div>
          <!-- 保存个人简历 -->
          <div class="resumeBtns">
            <button class="resumeCancel resumeCheckBtnItem" @click="cancelEdit()">取消</button>
            <button class="resumeSub resumeCheckBtnItem" @click="preserve()">保存</button>
          </div>
          <!-- 保存个人简历 -->
        </div>
      </div>
      <!-- 个人信息 -->
      <div class="personalCore-right-EditResumeVue">
        <div class="personalCore-right-info-EditResumeVue">
          <img :src="userInfo.userPhoto"/>
          <div class="personalCore-right-info-div-box-EditResumeVue">
            <div style="font-weight: bold">{{ userInfo.userName }}</div>
            <div style="margin-top: 13px;font-size: 16px;color: #3D3D3D">
              <span v-if="userInfo.age !== '' && userInfo.age !== undefined">{{ userInfo.age }}岁</span>
              <span v-if="userInfo.age !== '' && userInfo.age !== undefined && userInfo.edu !== '' && userInfo.edu !== undefined">|</span>
              <span v-if="userInfo.edu !== '' && userInfo.edu !== undefined">{{ userInfo.edu }}</span>
              <span v-if="userInfo.edu !== '' && userInfo.edu !== undefined && userInfo.condition !== '' && userInfo.condition !== undefined">|</span>
              <span v-if="userInfo.condition !== '' && userInfo.condition !== undefined">{{ userInfo.condition }}</span>
            </div>
          </div>
        </div>
        <div class="EditResumeVue-right-box">
          <div style="display: flex;padding: 24px 31px 20px;">
            <div class="personalCore-right-boxs-EditResumeVue" @click="resume()" style="margin-right: 24px;">
              <img src="../../assets/personalCore-icon4.png"/>
              <div>个人简历</div>
            </div>
            <div class="personalCore-right-boxs-EditResumeVue" @click="enroll()">
              <img src="../../assets/personalCore-icon2.png"/>
              <div>我的投递</div>
            </div>
          </div>
          <div style="display: flex;padding: 0px 31px 35px;">
            <div class="personalCore-right-boxs-EditResumeVue" @click="go()">
              <img src="../../assets/personalCore-icon3.png"/>
              <div>我的收藏</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      areaList: [],
      certificateList: [],
      conditionList: [],
      eduList: [],
      jobResume: {},
      jobTypeList: [],
      salaryList: [],
      typeList: [],
      cityList: [],
      workList: [],
      itemcount: 1,
      // EditwWorkList: [],
      districtList: [],
      tradeList: [],
      userInfo: {},
      isindustry: false,
      iscertificate: false,
      tradeListIndex: 0,
      tradeOneIndex: 0,
      tradeTowIndex: 0,
      certificateListIndex: 0,
      freshKey: 1,
      freshKeys: 1,
      tradeId: '',
      trade: '',
      province: '',
      provinceId: '',
      city: '',
      cityId: '',
      district: '',
      districtId: '',
      totalNum: 0,
      salary: '',
      salaryId: '',
      // jobType: '', // 求职类型
      certificate: '请选择证书',
      certificateId: '',
      imageSrc: '',
      inputName: [], // input要删除value的组一个数组
      workExpCompanyName: '', // 工作经历-公司名称
      workExpJobInfo: '', // 工作经历-职位
      workExpjobDescription: '', // 工作经历-描述  jobDescription: '',
      startWorkDay: '', // 2023-4-24开始工作时间
      cutoffWorkDay: '', // 2023-4-24结束工作时间
      salaryStaToEndKey: '', // 期望薪资区间
      newWorkList: [
        {
          // id: null,
          companyName: '', // 新增工作公司
          jobInfo: '', // 新增工作职位
          startTime: '', // 新增开始工作时间
          endTime: '', // 新增结束工作时间
          content: '' // 新增工作经历-描述
        }
      ],
      sex: '',
      sexId: ''
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  mounted () {

  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/resume`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.areaList = res.data.data.areaList
          that.areaId = res.data.data.areaList[0].id
          that.certificateList = res.data.data.certificateList
          that.conditionList = res.data.data.conditionList
          that.eduList = res.data.data.eduList
          that.jobResume = res.data.data.jobResume
          // if (that.jobResume.salaryId !== undefined) {
          //   that.salaryStaToEndKey = that.jobResume.salaryId
          // }
          if (that.jobResume.certificate !== undefined) {
            that.certificate = that.jobResume.certificateName
            that.certificateId = that.jobResume.certificate
          }
          if (that.jobResume.sex !== undefined) {
            if (that.jobResume.sex === '男') {
              that.sexId = 0
              that.sex = '男'
            } else {
              that.sexId = 1
              that.sex = '女'
            }
          }
          // 省市区调整
          that.provinceId = that.jobResume.province === undefined ? '' : Number(that.jobResume.province)
          if (that.provinceId != null && that.provinceId !== undefined && that.provinceId !== '') {
            this.handleArea(that.provinceId)
          }
          that.cityId = that.jobResume.city === undefined ? '' : Number(that.jobResume.city)
          if (that.cityId != null && that.cityId !== undefined && that.cityId !== '') {
            this.getDistrict()
          }
          that.districtId = that.jobResume.area === undefined ? '' : Number(that.jobResume.area)
          // 求职类型调整
          // that.jobResume.type === undefined ? '' : Number(that.jobResume.type)
          that.jobTypeList = res.data.data.jobTypeList
          that.salaryList = res.data.data.salaryList // 期望薪资
          // that.sexList = res.data.data.sexList
          that.typeList = res.data.data.typeList
          that.workList = res.data.data.workList
          var jobWorkList = res.data.data.jobResume.workList
          if (jobWorkList !== undefined && jobWorkList.length > 0) {
            that.newWorkList = []
            jobWorkList.forEach(function (item, index) {
              var obj = {
                id: item.id,
                companyName: item.companyName,
                jobInfo: item.jobInfo,
                content: item.content,
                startTime: item.startTime,
                endTime: item.endTime
              }
              that.newWorkList.push(obj)
            })
          }
          // 期望职位trade属性处理
          // that.jobResume.trade === undefined ? '' : that.jobResume.trade
          // id回填处理
          that.typeList.forEach(function (item, index) {
            if (res.data.data.jobResume.typeName === item.name) {
              that.jobResume.type = item.id
            }
          })
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取市
    getCity () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.provinceId
        })
      }).then(
        (res) => {
          that.cityList = res.data.data.areaList
          that.cityId = res.data.data.areaList[0].id
          that.getDistrict()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 获取区
    getDistrict () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/area/getAreaList`,
        data: JSON.stringify({
          id: that.cityId
        })
      }).then(
        (res) => {
          that.districtList = res.data.data.areaList
          that.districtId = res.data.data.areaList[0].id
        },
        (err) => {
          that.$message.error(err)
          // console.log(err)
        }
      )
    },
    test () {
      const file = this.$refs.fileInput.files[0]
      const fileReader = new FileReader()
      fileReader.onload = (temp) => {
        this.imageSrc = temp.target.result
        this.jobResume.logo = temp.target.result
      }
      fileReader.readAsDataURL(file)
    },
    empty (name) { // 清空input的value内容
      var that = this
      let index = that.inputName.findIndex(item => {
        if (item === name) {
          return true
        }
      })
      that.inputName.splice(index, 1)
      if (name === that.jobResume.name) {
        that.jobResume.name = ''
      }
      if (name === that.jobResume.school) {
        that.jobResume.school = ''
      }
    },
    // 行业
    selectIndustry () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/tradeList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.tradeList = res.data.data.tradeList
          that.isindustry = true
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    industryByGetData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/tradeList`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.tradeList = res.data.data.tradeList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    chooseTrade (id, name, index) {
      this.jobResume.trade = this.tradeList[this.tradeListIndex].id
      // this.jobResume.tradeId = this.tradeList[this.tradeListIndex].id
      this.jobResume.jobName = name
      this.jobResume.jobNameId = id
      this.isindustry = false
    },
    changePosition (e) {
      this.tradeListIndex = e
      this.freshKey = new Date().getTime()
    },
    checkCertificate (e) {
      var that = this
      that.certificateList[that.certificateListIndex].list.forEach(function (item, index) {
        if (item.id === e) {
          if (item.check === true) {
            item.check = false
          } else {
            item.check = true
          }
        }
      })
      that.$forceUpdate()
    },
    changePositions (e) {
      this.certificateListIndex = e
      this.freshKeys = new Date().getTime()
    },
    selectCertificateList () {
      var that = this
      var certificateName = []
      var certificateId = []
      that.certificateList.forEach(function (item, index) {
        item.list.forEach(function (i, j) {
          if (i.check === true) {
            certificateName.push(i.name)
            certificateId.push(i.id)
          }
        })
      })
      var certificateNames = certificateName.join(',')
      var certificateIds = certificateId.join(',')
      that.certificate = certificateNames
      that.certificateId = certificateIds
      that.iscertificate = false
    },
    close () { // 关闭
      this.isindustry = false
      this.iscertificate = false
    },
    opencertificate () {
      this.iscertificate = true
    },
    beforeHandleCommand (name, id) {
      return {
        id: id,
        name: name
      }
    },
    handleSex (value) {
      var that = this
      if (value === '男') {
        that.sexId = 0
        that.sex = '男'
      } else {
        that.sexId = 1
        that.sex = '女'
      }
    },
    handleWork (command) {
      var that = this
      that.jobResume.workId = command.id
      that.jobResume.work = command.name
    },
    handleEdu (command) {
      var that = this
      that.jobResume.eduId = command.id
      that.jobResume.edu = command.name
    },
    handleSalary (command) {
      var that = this
      that.salaryId = command.id
      that.salary = command.name
    },
    handleCondition (command) {
      var that = this
      that.jobResume.conditionId = command.id
      that.jobResume.condition = command.name
    },
    // 省
    handleArea (row) {
      var obj = {}
      obj = this.areaList.find(function (i) {
        return i.id === row
      })
      if (obj === undefined || obj == null) {
        return false
      }
      // 在change中获取到整条对象数据
      this.province = obj.name
      this.provinceId = obj.id
      this.city = ''
      this.cityId = ''
      this.district = ''
      this.districtId = ''
      this.getCity()
    },
    // 市
    handleCity (row) {
      var obj = {}
      obj = this.cityList.find(function (i) {
        return i.id === row
      })
      this.city = obj.name
      this.cityId = obj.id
      this.district = ''
      this.districtId = ''
      this.getDistrict()
    },
    // 区
    handleDistrict (row) {
      var obj = {}
      obj = this.districtList.find(function (i) {
        return i.id === row
      })
      this.district = obj.name
      this.districtId = obj.id
    },
    dataSearch () {
      this.getListByDay()
    },
    addWorkList () { // 新增工作经历
      this.newWorkList.push({
        companyName: '', // 新增工作公司
        jobInfo: '', // 新增工作职位
        startTime: '', // 新增开始工作时间
        endTime: '', // 新增结束工作时间
        content: '' // 新增工作经历-描述
      })
    },
    DeleteAddWorkList () { // 删除工作经历-1
      this.newWorkList.splice(this.newWorkList.length - 1, 1)
    },
    async initData (data) {
      var now = new Date()
      var monthn = now.getMonth() + 1
      var yearn = now.getFullYear()
      var dayn = now.getDate()
      this.selectDay = yearn + '-' + monthn + '-' + dayn
      // this.jobResume.graduationDate = yearn + '-' + monthn + '-' + dayn
      this.selectUser = parseInt(sessionStorage.getItem('userid'))
      this.getListByDay()
    },
    async getListByDay (data) {

    },
    cancelEdit () {
      this.$router.go(-1)
    },
    go () {
      this.$router.push({ path: '/myCollection' })
    },
    enroll () {
      this.$router.push({ path: '/myEnroll' })
    },
    // resume () {
    //
    // },
    preserve () { // 简历保存
      var that = this
      if (that.jobResume.name === '' || that.jobResume.name === undefined) {
        this.$message.error('请输入姓名')
        return false
      }
      if (that.sexId === '' || that.sexId === undefined) {
        this.$message.error('请选择性别')
        return false
      }
      if (that.jobResume.birthday === '' || that.jobResume.birthday === undefined) {
        this.$message.error('请选择出生日期')
        return false
      }
      if (that.jobResume.phone === '' || that.jobResume.phone === undefined) {
        this.$message.error('请输入电话')
        return false
      }
      if (that.jobResume.work === '' || that.jobResume.work === undefined) {
        this.$message.error('请选择工作经验')
        return false
      }
      if (that.jobResume.condition === '' || that.jobResume.condition === undefined) {
        this.$message.error('请选择当前状态')
        return false
      }
      if (that.jobResume.jobName === '' || that.jobResume.jobName === undefined) {
        this.$message.error('请选择期望职位')
        return false
      }
      if (that.provinceId === '') {
        this.$message.error('请选择所属省')
        return false
      }
      if (that.cityId === '') {
        this.$message.error('请选择所属市')
        return false
      }
      if (that.districtId === '') {
        this.$message.error('请选择所属区')
        return false
      }
      if (that.jobResume.type === '' || that.jobResume.type === undefined) {
        this.$message.error('请选择求职类型')
        return false
      }
      if (that.jobResume.salaryId === '' || that.jobResume.salaryId === undefined) {
        this.$message.error('请选择期望薪资')
        return false
      }
      if (that.jobResume.selfIntroduction === '' || that.jobResume.selfIntroduction === undefined) {
        this.$message.error('请输入自我介绍')
        // return false
      }
      if (that.newWorkList.companyName === '' || that.newWorkList.companyName === undefined) {
        // this.$message.error('请输入公司名称')
        // return false
      }
      if (that.newWorkList.jobInfo === '' || that.newWorkList.jobInfo === undefined) {
        // this.$message.error('请输入公司职位')
        // return false
      }
      if (that.newWorkList.startTime === '' || that.newWorkList.startTime === undefined) {
        // this.$message.error('请选择该工作开始时间')
        // return false
      }
      if (that.newWorkList.endTime === '' || that.newWorkList.endTime === undefined) {
        // this.$message.error('请选择该工作结束时间')
        // return false
      }
      if (that.newWorkList.content === '' || that.newWorkList.content === undefined) {
        // this.$message.error('请输入工作描述')
        // return false
      }
      if (that.jobResume.school === '' || that.jobResume.school === undefined) {
        this.$message.error('请输入学校名称')
        return false
      }

      if (that.jobResume.edu === '' || that.jobResume.edu === undefined) {
        this.$message.error('请选择学历')
        return false
      }
      if (that.jobResume.major === '' || that.jobResume.major === undefined) {
        this.$message.error('请输入专业')
        return false
      }
      if (that.jobResume.graduationDate === '' || that.jobResume.graduationDate === undefined) {
        this.$message.error('请选择毕业时间')
        return false
      }
      if (that.certificateId === '') {
        // this.$message.error('请选择资格证书')
        // return false
      }
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/addResume`,
        data: JSON.stringify({
          name: that.jobResume.name, // 姓名
          birthday: that.jobResume.birthday, // 生日
          sex: that.sexId, // 性别
          work: that.jobResume.work, // 工作年限
          condition: that.jobResume.condition, // 当前状态
          phone: that.jobResume.phone, // 手机号
          school: that.jobResume.school, // 学校
          workList: that.newWorkList, // 工作经历
          edu: that.jobResume.edu, // 学历
          major: that.jobResume.major, // 专业
          graduationDate: that.jobResume.graduationDate, // 毕业时间
          jobName: that.jobResume.jobName, // 期望职位
          trade: that.jobResume.trade, // 期望行业
          type: that.jobResume.type, // 求职类型
          province: that.provinceId, // 省
          city: that.cityId, // 市
          area: that.districtId, // 区
          salary: that.jobResume.salaryId, // 薪资范围
          certificate: that.certificateId, // 资格证书
          selfIntroduction: that.jobResume.selfIntroduction, // 自我介绍
          logo: that.imageSrc // 头像
        })
      }).then(
        (res) => {
          this.$message.success('修改成功')
          this.$router.push({ path: '/resume' })
        },
        (err) => {
          that.$message.error(err)
        }
      )
    }
  }
}
</script>

<style>

.resume-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 31px;
}

.resume-left {
  float: left;
  width: 857px;
  margin-right: 24px;
}

.resume-left-top {
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 21px;
  padding-bottom: 29px;
}

.resume-left-top-txt {
  float: left;
  overflow: hidden;
}

.resume-left-top-txt-img {
  width: 66px;
  height: 66px;
  float: left;
  margin-right: 17px;
  margin-top: 22px;
  margin-left: 36px;
  border-radius: 50%;
}

.resume-left-top-txt-info {
  float: left;
  margin-top: 22px;
}

.resume-left-top-txt-name {
  font-size: 18px;
  font-weight: 550;
}

.resume-left-top-txt-box {
  overflow: hidden;
  margin-top: 15px;
}

.resume-left-top-txt-one {
  float: left;
  overflow: hidden;
  margin-right: 23px;
}

.resume-left-top-txt-one img {
  width: 14px;
  height: 14px;
  float: left;
  margin-top: 3px;
  margin-right: 4px;
}

.resume-left-top-txt-one div {
  float: left;
  font-size: 14px;
}

.resume-left-top-txts {
  float: right;
  color: #027FFE;
  font-size: 16px;
  margin-right: 52px;
  margin-top: 30px;
}

.resume-modular {
  width: 857px;
  background-color: #fff;
  margin-bottom: 25px;
  padding-bottom: 20px;
}

.resume-modular-box {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin-bottom: 23px;
}

.resume-modular-title {
  float: left;
  position: relative;
}

.resume-modular-title img {
  width: 65px;
  height: 5px;
  left: 40px;
  position: absolute;
  top: 5px;
}

.resume-modular-title div {
  margin-top: 23px;
  /*margin-left: 41px;*/
  font-size: 22px;
  font-weight: 550;
}

.resume-modular-add {
  /*float: right;*/
  width: 14px;
  /*height: 14px;*/
  /*margin-right: 54px;*/
  /*margin-top: 29px;*/
  position: absolute;
  right: 1em;
  margin-top: 8px;
}

.resume-modular-tabel {
  /*margin-left: 41px;*/
  overflow: hidden;
  /*height: 49px;*/
  padding-top: 9px;
  padding-bottom: 10px;
  /*background: #F8F9FA;*/
  border: 1px solid #DFDFDF;
  position: relative;
}

.resume-modular-tabel div {
  float: left;
  font-size: 14px;
  line-height: 30px;
  min-height: 30px;
  padding-right: 26px;
  /*border-right: 2px solid #979797;*/
  margin-right: 25px;
  padding-left: 1em;
  color: #6a6f77;
}

.resume-modular-tabel div:last-child {
  border-right: none
}

.resume-modulars {
  width: 857px;
  background-color: #fff;
  margin-bottom: 25px;
  padding-bottom: 18px;
}

.resume-modular-titles {
  width: 100%;
  position: relative;
}

.resume-modular-titles img {
  width: 65px;
  height: 5px;
  left: 40px;
  position: absolute;
  top: 5px;
}

.resume-modular-titles div {
  padding-top: 23px;
  margin-left: 41px;
  font-size: 18px;
  font-weight: 550;
}

.resume-modular-introduce {
  width: 758px;
  padding: 12px 16px;
  margin: 0 auto;
  border: 1px solid #ECECEC;
  border-radius: 5px;
  margin-top: 19px;
}

.resume-menus {
  float: left;
  width: 307px;
  height: 421px;
  background-color: #fff;
}

.resume-menus div {
  width: 269px;
  height: 60.4px;
  line-height: 60.4px;
  padding-left: 28px;
}

/* 以上是resume的css
  以下是当前页面新增css*/
.resume-left-top-txt-box-one,
.resume-left-top-txt-box-two {
  height: 20px;
  line-height: 20px;
  margin-bottom: 17px;
}

.advantageTitle {
  font-size: 18px;
  height: 25px;
  line-height: 25px;
  color: #000;
}

.advantageTitle {
  margin-bottom: 17px;
}

.advantageTxt {
  outline: 0;
  box-sizing: border-box;
  font-size: 16px;
  height: 28px;
  border-radius: 4px;
  border: none;
  color: #6a6f77;
  display: block;
  outline: 0;
  text-decoration: none;
  width: 100%;
}

.resume-left-top-edit {
  margin-bottom: 90px;
}

.resume-left-top-add {
  text-align: center;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 0 auto;
  background: #DEF1FF;
  border: 1px solid #DEF1FF;
  border-radius: 50%;
}

.resume-left-top-add::before {
  content: "+";
}

.resume-left-top-addBox {
  width: 14px !important;
  height: 14px;
  border-radius: 50%;
  background: #DEF1FF;
  border: 1px solid #DEF1FF;
  color: #027FFE;
  font-size: 16px;
}

.resume-left-top-txt {
  width: 80%;
  margin-left: 36px;
}

.resume-left-top-txt-img {
  margin-left: 0;
}

input::placeholder {
  font-size: 14px;
  color: #888888;
}

.advantageBox {
  display: inline-block;
  width: 100%;
}

.resume-modular-fill {
  display: flex;
}

.resume-modular-fillBox {
  padding: 16px 30px 20px 30px;
  background-color: #fff;
  margin-bottom: 24px;
}

.resume-modular-filling {
  width: 857px;

  margin-bottom: 25px;
}

.fillBusinessDetails-name {
  float: left;
  overflow: hidden;
  height: 22px;
  line-height: 22px;
  margin-bottom: 14px;
  /*width: 72px;*/
  /*width: 23%;*/
  color: #6D6D6D;
  margin-right: 30px;
}

.fillResumeDetails-name {
  float: left;
  /*text-align: justify;*/
  height: 22px;
  line-height: 22px;
  /*width: 64px;*/
  font-size: 16px;
}

.fillResumeDetails-name::after {
  content: '';
  display: inline-block;
  width: 100%;
}

.resume-modular-fillTitle {
  font-size: 22px;
  font-weight: 550;
  position: relative;
  display: flex;
  height: 77px
}

.resume-modular-fill-title {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin-bottom: 25px;
  padding-top: 40px
}

.resume-fill-detils {
  box-sizing: border-box;
  font-size: 16px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 0 1em;
  text-decoration: none;
  width: 100%;
}

.resume-fillDetails {
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-box-flex: 1;
  overflow: hidden;
  margin-bottom: 26px;
  margin-right: 30px;
}

.resume-fillDetails:last-child {
  margin-right: 0;
}

.resume-fillDetails-headerPhoto {
  flex: 1;
  margin-bottom: 0;
  position: relative;
  margin-right: 0;
}

.resume-fillDetails-headerPhoto-file {
  opacity: 0;
  width: 141px;
  height: 188px;
  position: absolute;
  top: 1px;
  z-index: 11;
}

.resume-fillDetails-content {
  float: left;
  overflow: hidden;
  position: relative;
  width: 100%;
  cursor: pointer;
}

.resume-fillDetails-content-picker {
  width: 100% !important;
}

.resume-fillDetails-content-picker input {
  /*border: none;*/
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
}

/* 按钮 */
.resumeBtns {
  text-align: center;
  width: 100%;
  font-size: 16px;
  margin-top: 54px;
}

.resumeCheckBtnItem {
  width: 147px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.resumeCancel {
  /*border: 1px solid #B0A7A7;*/
  color: #6D6D6D;
  background: #fff;
  margin-right: 40px;
}

.resumeSub {
  color: #fff;
  /*border: 1px solid #587CF7;*/
  background: #587CF7;

}

.resume-fill-introduce {
  font-size: 14px;
  width: 100%;
}

.resume-fill-textarea {
  outline: 0;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  border: none;
  border: 1px solid #DFDFDF;
  color: #6a6f77;
  display: block;
  outline: 0;
  padding: 1em 1em;
  text-decoration: none;
  /*width: 746px;*/
  width: 100%;
  resize: none;
  /*background: #F8F9FA;*/
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.resume-fill-select {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 19px;
  color: #D8D8D8;
}

.asterisk {
  color: #FF0000;
  float: left;
  margin-top: -1px;
  font-size: 17px;
}

.project-dropdown {
  height: 250px;
  overflow: auto;
  /*width: 380px;*/
}

.project-dropdown::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}

.project-dropdown::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #F5F5F5;
}

.shade {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
.shade-unify{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .3);
  z-index: 998;
}
/* 行业 */
.hots-editResume {
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: -15px;
  margin-bottom: 20px;
  z-index: 999;
  position: fixed !important;
  left: 0;
  right: 0;
  /*height: 676px !important;*/
}
.hotss-unify{
  width: 1000px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: 24px;
  margin-bottom: 20px;
}
.hots-titles-unify{
  font-weight: 550;
  margin-left: 30px;
  padding-top: 14px;
  font-size: 18px;
}
.hots-contents-unify{
  overflow: hidden;
  margin-top: 18px;
}
.hots-left-unify{
  float: left;
  width: 218px;
  margin-right: 30px;
  height: 401px;
  overflow-y: auto;
}
.hots-left-label-unify div{
  color: #868686;
  height: 39px;
  line-height: 39px;
  font-size: 14px;
  padding-left: 40px;
  cursor: pointer;
}
.hots-left-unify .active{
  background-color: #F2F7FF;
  color: #027FFE;
}
.hots-right-box-unify{
  display: inline-block;
}
.hots-right-unify{
  float: left;
  width: 72%;
  font-size: 14px;
  height: 401px;
  margin-bottom: 10px;
  overflow-y:auto;
}
.hots-right-h1-unify{
  text-align: left;
  font-weight: 550;
  font-size: 16px;
  margin-bottom: 18px;
}
/*.hots-right-cont-unify{*/
/*  font-size: 14px;*/
/*  overflow: hidden;*/
/*  float: left;*/
/*}*/
.hots-right-cont-unify{
  float: left;
}
.hots-right-cont-unify div:nth-child(12n){
  margin-bottom: 30px;
}
.hots-right-cont-unify div{
  color: #A1A1A1;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  margin-bottom: 15px;
  cursor: pointer;
  width: 135px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.hots-right-cont-unify div:hover{
  color: #007aff;
  /*text-wrap: wrap;*/
}
.hots-editResume_isindustryEditResumevue{
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  margin-top: -15px;
  margin-bottom: 20px;
  z-index: 999;
  position: fixed !important;
  left: 0;
  right: 0;
  height: 500px !important;
}
.hots-titles {
  font-weight: 550;
  margin-left: 30px;
  padding-top: 14px;
  font-size: 18px;
}

.hots-contents {
  overflow: hidden;
  margin-top: 18px;
  background: #fff;
}

.hots-left {
  float: left;
  width: 218px;
  margin-right: 30px;
  height: 401px;
  overflow-y: auto;
}

.hots-left-label div {
  color: #868686;
  height: 39px;
  line-height: 39px;
  font-size: 14px;
  padding-left: 40px;
  cursor: pointer;
}

.hots-left .active {
  background-color: #F2F7FF;
  color: #027FFE;
}

.hots-right {
  float: left;
  width: 78%;
  font-size: 14px;
  height: 401pxpx;
  margin-bottom: 10px;
  overflow-y: auto;
}
.hots-right-box_industry{
  float: left;
}
.hots-right-box_industry:nth-child(12n){
  margin-bottom: 30px;
}
.hots-right-box {
  margin-top: 18px;
}

.hots-right-box:first-child {
  margin-top: 0;
}

.hots-right-h1 {
  text-align: left;
  font-weight: 550;
  font-size: 16px;
  margin-bottom: 18px;
}

.hots-right-cont {
  font-size: 14px;
  overflow: hidden;
}

.hots-right-cont-divs {
  color: #A1A1A1;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  margin-bottom: 17px;
  cursor: pointer;
  width: 135px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.hots-right-cont-div {
  color: #A1A1A1;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  margin-bottom: 17px;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  background-color: #F1F2F6;
}

.hots-right-cont-active {
  color: #fff !important;
  background-color: #027FFE;
}

.hots-btns {
  overflow: hidden;
  padding-bottom: 20px;
  padding-top: 20px;
}

.hots-btns div:first-child {
  float: right;
  background-color: #587CF7;
  color: #fff;
  width: 116px;
  text-align: center;
  height: 39px;
  line-height: 39px;
  margin-right: 16px;
  margin-left: 26px;
}

.hots-btns div:last-child {
  float: right;
  border: 1px solid #B0A7A7;
  width: 114px;
  height: 37px;
  line-height: 37px;
  text-align: center;
  color: #B0A7A7;
}

.pull-down-icon-box {
  height: 36px;
  line-height: 36px;
  position: absolute;
  right: 10px;
  top: 0
}

.el-dropdown-menu {
  padding: 0;
}

.resume-modular-title-name {
  /*margin-top: 23px;*/
  /* margin-left: 41px; */
  height: 25px;
  line-height: 25px;
  margin-bottom: 21px;
  font-size: 18px;
  font-weight: 550;
}

.resume-fillDetails-headerPhoto-after {
  width: 138px;
  height: 186px;
  margin-top: 1px;
  margin-left: 1px;
}

.resume-fillDetails-headerPhoto-after:after {
  content: '';
  background: url("../../assets/photo-add.png");
  font-size: 12px;
  width: 140px;
  height: 188px;
  text-align: center;
  color: #c1c1c1;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
}

/*.resume-fillDetails-headerPhoto:after{*/
/*  content: '';*/
/*  background: url("../../assets/photo-add.png");*/
/*  font-size: 12px;*/
/*  width: 140px;*/
/*  height: 188px;*/
/*  text-align: center;*/
/*  color: #c1c1c1;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  background-size: 100% 100%;*/
/*}*/
.resume-fillDetails-content-sex {
  flex: 1;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border: 1px solid #DFDFDF;
  color: #6D6D6D;
  font-size: 16px;
  margin-right: 23px;
}

.resume-fillDetails-content-sex-active {
  background: #EEF8FF;
  color: #0091FF;
  border: 1px solid #0091FF;
}

.resume-fillDetails-content-sex:last-child {
  margin-right: 0;
}
.personalCore-right-EditResumeVue {
  width: 307px;
  float: left;
  height: 421px;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 16px;
}

.personalCore-right-info-EditResumeVue {
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}

.personalCore-right-info-EditResumeVue img {
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 30px;
  border-radius: 50%;
}

.personalCore-right-info-EditResumeVue div {
  /*float: left;*/
  margin-top: 34px;
  font-size: 18px;
}

.EditResumeVue-right-box {
  width: 100%;
}

.personalCore-right-boxs-EditResumeVue {
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.personalCore-right-boxs-EditResumeVue img {
  width: 100%;
  height: 100%;
}

.personalCore-right-boxs-EditResumeVue div {
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.jobResumeWork,.jobResumeCondition,.jobResumeType,.testMoney-editResume,.jobResumeEdu-editResume{
  width: 100%;
}
.jobResumeWork input,.jobResumeCondition input,.jobResumeType input,.testMoney-editResume input,.jobResumeEdu-editResume input{
  height: 36px;
  line-height: 36px;
  border-radius: 0;
}
.cityItem-editResume input{
  border-radius: 0;
  /*border: none;*/
}
.el-radio-button__inner {
  padding: 0 !important;
  border-radius: 4px !important;
  height: 36px !important;
  line-height: 36px !important;
  width: 131px !important;
  /*border-left: 1px !important;*/
  border: 1px solid #DFDFDF;
}
.el-radio-button__inner-EditResume {
  padding: 0 !important;
  border-radius: 4px !important;
  height: 36px !important;
  line-height: 36px !important;
  width: 46% !important;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #0091FF;
  background-color: #EEF8FF;
  border-color: #409EFF;
  -webkit-box-shadow: -1px 0 0 0 #409EFF;
  box-shadow: -1px 0 0 0 #409EFF;
  /*border: none;*/
}
.el-radio-button__inner, .el-radio-button__inner-EditResume{
  /*border: none;*/
  /*border-left: none !important;*/
}
.el-radio-group label{
  /*border-left: 0 !important;*/
}
/*请选择职位类别滚动条样式*/
.hots-left-unify::-webkit-scrollbar,
.hots-right-unify::-webkit-scrollbar{
  width: 14px;
  height: 14px;
}

.hots-left-unify::-webkit-scrollbar-track,
.hots-left-unify::-webkit-scrollbar-thumb,
.hots-right-unify::-webkit-scrollbar-track,
.hots-right-unify::-webkit-scrollbar-thumb{
  border-radius: 999px;
  border: 5px solid transparent;
}

.hots-left-unify::-webkit-scrollbar-track,
.hots-right-unify::-webkit-scrollbar-track{
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}

.hots-left-unify::-webkit-scrollbar-thumb,
.hots-right-unify::-webkit-scrollbar-thumb{
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}

.hots-left-unify::-webkit-scrollbar-corner,
.hots-right-unify::-webkit-scrollbar-corner{
  background: transparent;
}
/*证书滚动条*/
/*.hots-left::-webkit-scrollbar{*/
/*  width: 14px;*/
/*  height: 14px;*/
/*}*/
/*.hots-left::-webkit-scrollbar-track,*/
/*.hots-left::-webkit-scrollbar-thumb,{*/
/*  border-radius: 999px;*/
/*  border: 5px solid transparent;*/
/*}*/

/*.hots-left::-webkit-scrollbar-track{*/
/*  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;*/
/*}*/
/*.hots-left::-webkit-scrollbar-thumb{*/
/*  min-height: 20px;*/
/*  background-clip: content-box;*/
/*  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;*/
/*}*/

/*.hots-left::-webkit-scrollbar-corner{*/
/*  background: transparent;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/jobSeekers/editResume.vue